<div class="summary">
  <div class="risk-section">
    <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.summary.risk-title' | translate }}</h4>
    <div class="split-section">
      <div>
        <p>
          <span>{{ 'new_strategy.risk_screen.slider.stocks' | translate }}</span>
          <span>
            <app-ui-tooltip
              [content]="
                'new_strategy.portfolio_screen.stock_ratio.tooltip'
                  | translate: { percentage: investmentData.stock_split * 100 | translatePercent: customer.language : 0 }
              "
              color="yellow"
              size="small"
              (mouseenter)="trackTooltip('stocks')"
            ></app-ui-tooltip>
          </span>
        </p>
        <p class="numbers">
          {{ getStockBondValue('stock') | translatePercent: customer.language : (currentAccount.step_status === 5 ? 1 : 0) }}
        </p>
      </div>
      <div>
        <p>
          <span [innerHTML]="'strategy.stockSplit.bonds' | translate"></span>
          <app-ui-tooltip [content]="'bonds.tooltip.p' | translate" color="yellow" size="small" (mouseenter)="trackTooltip('bonds')"></app-ui-tooltip>
        </p>
        <p class="numbers">
          {{ getStockBondValue('bond') | translatePercent: customer.language : (currentAccount.step_status === 5 ? 1 : 0) }}
        </p>
      </div>
    </div>
    <div class="bar-section">
      <div class="bar" [style.width]="investmentData.stock_split * 100 + '%'"></div>
    </div>
  </div>
  <div class="contribution-section">
    <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.summary.contribution-title' | translate: { year: getCurrentYear() } }}</h4>
    <ng-container *ngIf="depositType !== 'transfer_only'; else showNoDeposit">
      <div class="split-section">
        <div *ngIf="depositType.length === 0 || depositType === 'small'">
          <p>{{ 'new_strategy.portfolio_screen.summary.with-pension' | translate }}</p>
          <p class="numbers">
            {{ MAXIMUM_3A_CONTRIBUTION[getCurrentYear()].small | translateNumber: customer.language : currentAccount.currency }}
          </p>
        </div>
        <div *ngIf="depositType.length === 0 || depositType === 'large'">
          <p>{{ 'new_strategy.portfolio_screen.summary.without-pension' | translate }}</p>
          <p class="numbers">
            {{ MAXIMUM_3A_CONTRIBUTION[getCurrentYear()].large | translateNumber: customer.language : currentAccount.currency }}
            <app-ui-tooltip
              [content]="
                'new_strategy.portfolio_screen.3a_box.info'
                  | translate: { max_large_contribution: MAXIMUM_3A_CONTRIBUTION[getCurrentYear()].large | translateNumber: customer.language }
              "
              color="yellow"
              size="small"
              (mouseenter)="trackTooltip('withoutPension')"
            ></app-ui-tooltip>
          </p>
        </div>
      </div>
    </ng-container>
    <ng-template #showNoDeposit>
      <div class="split-section no-deposit">
        <p>
          {{ 'new_strategy.portfolio_screen.summary.no-new-deposit' | translate }}
          <app-ui-tooltip
            [content]="'new_strategy.portfolio_screen.summary.no-new-deposit-tooltip' | translate"
            color="yellow"
            size="small"
            (mouseenter)="trackTooltip('noNewDeposit')"
          ></app-ui-tooltip>
        </p>
      </div>
    </ng-template>
    <p class="info" *ngIf="currentAccount.step_status < 5">
      {{
        'minimumInvestmentNote.full.inyova3a'
          | translate: { '3aMinimumInvestmentAmount': MINIMUM_INVESTMENT | translateNumber: customer.language : currentAccount.currency }
      }}
    </p>
  </div>
</div>
